/*!
 * vue-plugin-lognotifier v0.0.1
 * rimoldi@ditoy.com
 * Released under the MIT License.
 */
'use strict'

import axios from 'axios'

class LogNotifier {
  url = null
  consoleOutput = false
  remoteOutput = true
  config (options) {
    if (typeof (options) === 'object') {
      if (options.hasOwnProperty('url')) {
        this.url = options.url
      }
      if (options.hasOwnProperty('consoleOutput')) {
        this.consoleOutput = options.consoleOutput
      }
    }
  }
  logException (value) {
    if (typeof value.message === 'undefined') { value.message = 'exception' }
    if (typeof value.info === 'undefined') { value.info = {} }
    if (this.consoleOutput) {
      console.log(value.message, value.error)
    }
    if (this.remoteOutput) {
      let formData = new FormData() // eslint-disable-line no-undef
      formData.append('value', value.error)
      formData.append('message', value.message)
      formData.append('info', JSON.stringify(value.info))
      axios.request({
        url: this.url,
        method: 'post',
        data: formData,
        headers: {
          // 'Content-Type': 'multipart/form-data'
        }
      })
    }
  }
}

let logNotifier = new LogNotifier()

export default function VuePluginLogNotifier (Vue) {
  Vue.prototype.$initLog = function (options) {
    logNotifier.config(options)
  }
  Vue.prototype.$logException = function (e, message) {
    logNotifier.logException(e, message)
  }
}

VuePluginLogNotifier.version = '0.0.1'

// module.exports = VuePluginLocalforage




// WEBPACK FOOTER //
// ./src/lib/vue-plugin-lognotifier.js